export enum ActionsTab {
    pending = 'pending',
    completed = 'completed',
}
